const dom = {};

/**
 *
 */
export class LoadMedias {
    selector = ".imgdyn"; // default. Mais peut être changé. Ex: .videodyn
    type = 'image';
    loadedClass = "loaded";
    //
    loaded = 0;
    nb = 0; // il faut lancer this.load() pour incrémenter
    complete = false;
    //
    onload = false;
    oncomplete = false;
    delay = 0; // en ms. Attend delay ms avant de lancer (simule slow loading !!!! JUSTE POUR TEST)

    /**
     * @param {object?} options : (opt)
     */
    constructor(options = {}) {
        for (let key in options) {
            this[key] = options[key];
        }
    }

    /**
     * Récupère dans les images sur un élément ou dans toute la page
     * @returns {LoadMedias}
     */
    load() {
        const $parents = [...document.querySelectorAll(this.selector)];
        this.nb = $parents.length;
        if(this.type === 'image')
            $parents.forEach(this.createImg, this);
        else if(this.type === 'video')
            $parents.forEach(this.createVideo, this);
        return this;
    }

    /**
     * Créé l'objet js img à l'intérieur d'un parent
     * @param {Element} $parent
     * @return {HTMLImageElement[]} renvoi les img créées dans un array
     */
    createImg($parent) {
        let $img = new Image();
        const mediaAttributes = this.extractMediaAttributes($parent);
        if(mediaAttributes){//console.log({mediaAttributes});
            $img.onload = () => {
                this.loaded++;
                if (this.delay > 0) {
                    window.setTimeout(() => {
                        this.writeInDom($parent, $img);
                        this.playCallbacks($img);
                    }, this.delay);
                } else {
                    this.writeInDom($parent, $img);
                    this.playCallbacks($img);
                }
            };
            $img = this.applyMediaAttributes($img, mediaAttributes);
        }
        return $img;
    }

    /**
     * Créé l'objet js img à l'intérieur d'un parent
     * @param {Element} $parent
     * @return {HTMLVideoElement[]} renvoi les videos créées dans un array
     */
    createVideo($parent) {
        let $video = document.createElement("video");
        const mediaAttributes = this.extractMediaAttributes($parent);
        if(mediaAttributes){
            $video = this.applyMediaAttributes($video, mediaAttributes);
            /////////////////////////////////////////////////////////////////////
            //$video.autoplay = true;
            //$video.loop = true;
            //$video.muted = true;
            //////////////////////////////// douce santé //////////////////////////////////////
            $video.controls = true;
            ////$video.poster = VDB__CONFIG.url.theme_img+'/photo-2.jpg';// Miniature choisie de la vidéo
            ///////////////////////////////////////////////////////////////////////////////////
            $video.oncanplaythrough = () => {
                this.loaded++;
                if (this.delay > 0) {
                    window.setTimeout(() => {
                        this.writeInDom($parent, $video);
                        this.playCallbacks($video);
                        $video.oncanplaythrough = null;
                    }, this.delay);
                } else {
                    this.writeInDom($parent, $video);
                    this.playCallbacks($video);
                    $video.oncanplaythrough = null;
                }   
            };
        }
        return $video;
    }

    /**
     * Ajoute dans le dom
     * @param {Element} $parent
     * @param {HTMLImageElement|HTMLVideoElement} $media
     */
    writeInDom($parent, $media) {
        $media.classList.add(this.loadedClass);
        $parent.parentNode.replaceChild($media, $parent);
    }

    /**
     * Joue les callbacks après chargement
     * @param Element $media
     */
    playCallbacks($media) {
        if (typeof this.onload === "function") {
            this.onload($media, this);
        }
        if (this.loaded === this.nb) {
            this.complete = true;
            if (typeof this.oncomplete === "function") {
                this.oncomplete($media, this);
            }
        }
    }
    
    /**
     * Sépare les données contenues dans data-media-attributes (par le "|")
     * @param {Element} $element 
     * @returns {object|FALSE}
     */
    extractMediaAttributes($element){
        const attributes = $element.dataset.mediaAttributes;
        if(attributes){
            return attributes.split('|').reduce((out, keyvalue)=>{
                const [key,value] = keyvalue.split('=');
                out[key] = value;
                return out;
            }, {} );
        }
        return false;
    }

    /**
     * Applique les media attributes (extrait par this.extractMediaAttributes)
     * @param {Element} $element 
     * @param {object} mediaAttributes 
     * @returns {Element}
     */
    applyMediaAttributes($element, mediaAttributes){
        for(let key in mediaAttributes){
            // CAS spécial
            if(key === "fullSrc"){
                $element.setAttribute("data-full-src", mediaAttributes[key]);
                //... d'autres cas spéciaux éventuels
            // CAS regular
            } else {
                $element.setAttribute(key, mediaAttributes[key]);
            }
        } return $element;
    }

    /**
     * 
     * @param {Element} $element 
     */
    extractVideoExtra($element){
        //
    }
}
